import { AGE_TYPES, SECONDARY_ID_TYPES } from "../enum/enum"
export const ageLimits = {
  title: "Age Limits",
  type: "object",
  properties: {
    minimum: {
      type: "object",
      properties: {
        minimum_age_type: {
          type: "string",
          enum: [],
          options: AGE_TYPES,
        },
        minimum_age_value: {
          type: "string",
        },
      },
    },
    maximum: {
      type: "object",
      properties: {
        maximum_age_type: {
          type: "string",
          enum: [],
          options: AGE_TYPES,
        },
        maximum_age_value: {
          type: "string",
        },
      },
    },
  },
}

export const getSecondaryIds = (type = "ctg") => {
  return {
    type: "array",
    items: {
      type: "object",
      properties: {
        secondary_id_type: {
          type: "string",
          enum: [],
          options: SECONDARY_ID_TYPES.filter((option) => {
            if (type === "ctg" && (option.value === "CTMS ID" || option.value === "Alias ID")) return false
            return true
          }),
        },
        id: {
          title: "Identifier",
          type: "string",
        },
      },
      dependencies: {
        secondary_id_type: {
          oneOf: [
            {
              properties: {
                secondary_id_type: {
                  enum: ["Other Grant/Funding Number"],
                },
                domain: {
                  title: "Grantor or Funder",
                  type: "string",
                },
              },
            },
            {
              properties: {
                secondary_id_type: {
                  enum: ["Registry Identifier"],
                },
                domain: {
                  title: "Registry Name",
                  type: "string",
                },
              },
            },
            {
              properties: {
                secondary_id_type: {
                  enum: ["Other Identifier"],
                },
                domain: {
                  title: "Issuing Organization",
                  type: "string",
                },
              },
            },
          ],
        },
      },
    },
  }
}
